import { render, staticRenderFns } from "./ClickatellCredentialsForm.vue?vue&type=template&id=4047d5f8&scoped=true"
import script from "./ClickatellCredentialsForm.vue?vue&type=script&lang=js"
export * from "./ClickatellCredentialsForm.vue?vue&type=script&lang=js"
import style0 from "./ClickatellCredentialsForm.vue?vue&type=style&index=0&id=4047d5f8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4047d5f8",
  null
  
)

export default component.exports